export function skipTampon(skipFrom: string | null, skipUntil: string | null) {
  return {
    type: skipTampon.type,
    payload: { skipFrom, skipUntil },
  } as const;
}

skipTampon.type = 'tampon/skip' as const;
